import { useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import { useProducts } from '../../../shared/hooks/useProducts';
import { LoadingTile, ProductTile } from '../../product-grid/product-grid-tile';
import ArrowLeft from '../../../assets/icons/arrow_carrousel_left';
import ArrowRight from '../../../assets/icons/arrow_carrousel_right';
import clsx from 'clsx';

import 'swiper/css';
import style from './style.module.scss';

export const ProductSlider = ({ activeLang, productIds, title = '' }) => {
    const navigationNextRef = useRef(null);
    const navigationPrevRef = useRef(null);

    const swiperProps = {
        className: style.swiper,
        slidesPerView: 1.5,
        spaceBetween: 12,
        navigation: {
            nextEl: navigationNextRef.current,
            prevEl: navigationPrevRef.current,
            disabledClass: style.disabled,
            hiddenClass: style.disabled,
        },
        onBeforeInit: (swiper) => {
            swiper.params.navigation.prevEl = navigationPrevRef.current;
            swiper.params.navigation.nextEl = navigationNextRef.current;
        },
        modules: [Navigation],
        breakpoints: {
            767: {
                slidesPerView: 3.5,
                spaceBetween: 25,
            },
            992: {
                slidesPerView: 4.5,
            },
        },
    };

    const { productsLoading, products } = useProducts({
        include: productIds,
        lang: activeLang ?? 'fr',
    });

    return (
        <div className={style.slider}>
            <div className={style.header}>
                {title && title.length > 0 && <p className={style.title}>{title}</p>}
                <div className={style.navigation}>
                    <ArrowLeft className={clsx(style.prev, 'swiper-button-prev')} ref={navigationPrevRef} />
                    <ArrowRight className={clsx(style.next, 'swiper-button-next')} ref={navigationNextRef} />
                </div>
            </div>
            {(productsLoading || products.length > 0) && (
                <Swiper {...swiperProps}>
                    {(productsLoading ? Array.from(new Array(3)) : products).map((product, i) => {
                        return (
                            <SwiperSlide key={product ? 'cross_selling_' + product.id : 'loading_tile_' + i}>
                                {product ? <ProductTile product={product} showTags={false} /> : <LoadingTile />}
                            </SwiperSlide>
                        );
                    })}
                </Swiper>
            )}
        </div>
    );
};
